"use strict";
/**
 * Set of default configurations
 */

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.is-array");

var _toConsumableArray = require("/Users/andrewxia/Documents/work/nat/natmegy/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

var _defineProperty = require("/Users/andrewxia/Documents/work/nat/natmegy/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DEFAULT_OPTIONS = {
  output: "string",
  defaultMarker: "_DEFAULT_",
  joinSpaces: "",
  likes: [],
  precedences: []
};
/**
 * process a set of arguments based on given configuration
 * returning classnames as a string or an array depending on configuration
 *
 * @param {object} options - configurations to define the processing
 * @param  {...(string | array | object)} args - class name parameters to join
 */

var _process = function _process(options) {
  var joinSpaces = options.joinSpaces,
      output = options.output,
      defaultMarker = options.defaultMarker;

  var arrayOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), {}, {
    output: "array"
  }); // same options, just change the output


  var classes = [];

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  args.filter(function (arg) {
    return Boolean(arg);
  }).forEach(function (arg) {
    switch (typeof arg) {
      case "string":
        if (joinSpaces) {
          classes.push(arg.split(" ").join(joinSpaces)); // combine spaces
        } else {
          var _classes;

          (_classes = classes).push.apply(_classes, _toConsumableArray(arg.split(" ")));
        }

        break;

      case "object":
        if (Array.isArray(arg)) {
          var _classes2;

          (_classes2 = classes).push.apply(_classes2, _toConsumableArray(_process.apply(void 0, [arrayOptions].concat(_toConsumableArray(arg))))); // unpack arrays

        } else {
          var _classes3;

          var validKeys = Object.keys(arg).filter(function (k) {
            return Boolean(arg[k]) && arg[k] !== defaultMarker;
          }); // fetch default option when required

          var defaultClass = Object.keys(arg).find(function (k) {
            return arg[k] === defaultMarker;
          });

          if (validKeys.length == 0 && defaultClass) {
            validKeys.push(defaultClass);
          }

          (_classes3 = classes).push.apply(_classes3, _toConsumableArray(_process.apply(void 0, [arrayOptions].concat(_toConsumableArray(validKeys))))); // unpack object

        }

        break;

      default:
        classes.push(String(arg)); // just get the string representation of everything else

        break;
    }
  });
  classes = classes.map(function (name) {
    return name.trim();
  }).filter(function (name) {
    return Boolean(name);
  }).sort(); // sort to ensure consistency

  return output === "array" ? classes : classes.join(" ").trim();
};
/**
 * override base classnames with dominant classnames
 * returns classnames as a string or array
 *
 * @param {object} options - configurations to define processing
 * @param {string} base - base classnames
 * @param {string} dominant - dominant classnames
 */


var _override = function _override(options, base, dominant) {
  var _classes4, _classes5;

  var likes = options.likes,
      output = options.output,
      precedences = options.precedences;

  var baseClasses = _process(_objectSpread(_objectSpread({}, options), {}, {
    output: "array"
  }), base); // preprocess base classes as array


  var dominantClasses = _process(_objectSpread(_objectSpread({}, options), {}, {
    output: "array"
  }), dominant); // preprocess dominant classes as array
  // get regular expressions in likes and precedences


  var likesRegex = likes.map(function (like) {
    return new RegExp(like);
  });
  var precedenceRegex = precedences.map(function (_ref) {
    var dominant = _ref.dominant,
        base = _ref.base;
    return {
      dominant: dominant.map(function (d) {
        return new RegExp(d);
      }),
      base: base.map(function (b) {
        return new RegExp(b);
      })
    };
  });
  var classes = []; // only add base classes if they do not interfere with a dominant class

  (_classes4 = classes).push.apply(_classes4, _toConsumableArray(baseClasses.filter(function (base) {
    return !likesRegex.some(function (like) {
      return dominantClasses.some(function (dominant) {
        return like.test(base) && like.test(dominant);
      });
    }) && !precedenceRegex.some(function (precedence) {
      return precedence.dominant.some(function (precedenceDominant) {
        return dominantClasses.some(function (dominant) {
          return precedenceDominant.test(dominant);
        });
      }) && precedence.base.some(function (precedenceBase) {
        return precedenceBase.test(base);
      });
    });
  }))); // add all dominant classes


  (_classes5 = classes).push.apply(_classes5, _toConsumableArray(dominantClasses));

  classes = classes.map(function (name) {
    return name.trim();
  }).filter(function (name) {
    return Boolean(name);
  }).sort();
  return output === "array" ? classes : classes.join(" ").trim();
};
/**
 * set options for processing, returning possible downstream functions to run
 *
 * @param {object} options
 */


var _setOptions = function _setOptions(options) {
  var processOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options); // check for option validity


  var output = processOptions.output,
      joinSpaces = processOptions.joinSpaces,
      likes = processOptions.likes,
      precedences = processOptions.precedences;

  if (output !== "string" && output !== "array") {
    throw new Error("The `output` option must be either `string` or `array`");
  }

  if (!joinSpaces && joinSpaces !== "" || typeof joinSpaces !== "string") {
    throw new Error("The `joinSpaces` option must be a string");
  }

  if (!likes || typeof likes !== "object" || !Array.isArray(likes) || likes.some(function (like) {
    return !(like instanceof RegExp);
  })) {
    throw new Error("The `likes` option must be an array of regular expressions");
  }

  if (!precedences || typeof precedences !== "object" || !Array.isArray(precedences) || precedences.some(function (_ref2) {
    var dominant = _ref2.dominant,
        base = _ref2.base;
    return !dominant || typeof dominant !== "object" || !Array.isArray(dominant) || dominant.some(function (d) {
      return !(d instanceof RegExp);
    }) || !base || typeof base !== "object" || !Array.isArray(base) || base.some(function (b) {
      return !(b instanceof RegExp);
    });
  })) {
    throw new Error("The `precedences` option must be an array of objects with two parameters, `dominant` and `base`, referring to a list of regular expressions");
  }

  return {
    process: function process() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _process.apply(void 0, [processOptions].concat(args));
    },
    p: function p() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _process.apply(void 0, [processOptions].concat(args));
    },
    override: function override() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _override.apply(void 0, [processOptions].concat(args));
    },
    ovr: function ovr(base, dominant) {
      return _override(processOptions, base, dominant);
    }
  };
};
/**
 * Default processing
 *
 * @param  {...( string | object | array )} args
 */


var Index = function Index() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return _process.apply(void 0, [DEFAULT_OPTIONS].concat(args));
};

Index.process = function () {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  return _process.apply(void 0, [DEFAULT_OPTIONS].concat(args));
};

Index.p = function () {
  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  return _process.apply(void 0, [DEFAULT_OPTIONS].concat(args));
};

Index.opt = _setOptions;
Index.o = _setOptions;
module.exports = Index;